import type { ToastIntent } from "@fluentui/react-components";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IToastItem {
  id: string;
  message: string;
  intent: ToastIntent;
}

interface IToastState {
  queue: IToastItem[];
}

const initialState: IToastState = { queue: [] };

const toastSlice = createSlice({
  name: "toastSlice",
  initialState,
  reducers: {
    enqueueToast: (state, action: PayloadAction<IToastItem>) => {
      state.queue.push(action.payload);
    },
    dequeueToast: (state, action: PayloadAction<string>) => {
      state.queue = state.queue.filter((t) => t.id !== action.payload);
    },
  },
});

export const { enqueueToast, dequeueToast } = toastSlice.actions;
export default toastSlice.reducer;
